/* eslint-disable no-shadow */
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Checkbox, InputLabel, ListItemText, MenuItem, Select,
} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import FormControl from "@mui/material/FormControl";

const StyledFormControl = styled(FormControl, {
    shouldForwardProp: (prop) => !["fullHeight", "onClick", "value", "label", "neededWidth"].includes(prop),
})(({
    theme, onClick, value, label, neededWidth,
}) => ({
    "& .Mui-disabled fieldset": {
        backgroundColor: theme.palette.action.disabledBackground,
    },
    "& .Mui-disabled": {
        color: `${theme.palette.text.primary}!important`,
        WebkitTextFillColor: "initial",
    },
    "& .MuiOutlinedInput-root": {
        background: "none",
        fontSize: 12,
        margin: 0,
        padding: 0,
        "& .Mui-disabled": {
            cursor: (onClick && value) && "pointer",
            color: (onClick && value) && "#4594AD",
            textDecoration: (onClick && value) && "underline",
            "&:hover": {
                color: (onClick && value) && "inherit",
            },
        },
        "& .MuiOutlinedInput-notchedOutline": {
            "&  legend": {
                border: "none",
            },
            top: 0,
            height: 24,
            ...label && {
                marginTop: 12,
            },
        },
        "& .MuiOutlinedInput-input": {
            paddingTop: 4,
            paddingBottom: 2,
            paddingLeft: 3,
            paddingRight: 3,
            ...label && {
                marginTop: 13,
            },
        },
        "& .MuiIconButton-root": {
            minWidth: 16,
            marginRight: 4,
        },
        ...label ? {
            marginTop: 2,
            "& .MuiSelect-iconOutlined": {
                marginTop: 7,
            },
        } : {
            "& .MuiSelect-iconOutlined": {
                marginTop: "1px!important",
            },
            "&>*:not(.MuiOutlinedInput-notchedOutline):not(.MuiSelect-select)": {
                marginTop: 2,
            },
            "& .MuiSelect-select": {
                marginTop: 0.75,
            },
        },
        ...neededWidth && {
            display: "contents",
        },
    },
    "& .MuiInputLabel-shrink": {
        fontSize: 12,
        transform: "translate(2px, -7px) scale(1) !important",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
        display: "none",
    },
    "& .MuiSelect-select": {
        paddingRight: "10px!important",
        ...neededWidth && {
            paddingRight: "20px!important",
        },
    },
    "& .MuiSelect-icon": {
        marginRight: -4,
    },
    // },
    ...label ? {
        height: 36,
    } : {
        height: 24,
    },
    ...neededWidth && {
        display: "table",
    },
}));

const getOption = (option, optionsFormat, optionsName) => {
    if (optionsFormat) {
        return optionsFormat(option);
    }
    if (optionsName) {
        return option[optionsName];
    }
    return option;
};
function CustomMultiSelect(props) {
    const {
        fullWidth,
        neededWidth,
        disabled,
        required,
        label,
        value,
        onChange,
        options,
        optionsKey,
        optionsName,
        sx,
        error,
        onClick,
        optionsFormat,
        disableEmptySelection,
    } = props;

    const [selected, setSelected] = useState(value);

    const handleChange = (event) => {
        const { value } = event.target;
        if (value[value.length - 1] === "all") {
            const allValues = selected.length === options.length ? [] : options.map((option) => option[optionsKey]);
            setSelected(allValues);
            if (onChange) onChange(allValues);
            // return;
        } else {
            setSelected(value);
            if (onChange) onChange(value);
        }
    };

    return (
        <StyledFormControl
            variant="outlined"
            fullWidth={fullWidth}
            disabled={disabled}
            required={required}
            sx={sx}
            error={error}
            onClick={onClick}
            value={value}
            label={label}
            neededWidth={neededWidth}
        >

            {label ? (
                <InputLabel>
                    {label}
                </InputLabel>
            ) : null}

            <Select
                multiple
                sx={{ maxWidth: !fullWidth ? "800px" : "100%", ...sx }}
                value={value || []}
                onChange={handleChange}
                renderValue={
                    (selected) => options?.filter((option) => selected.includes(option[optionsKey])).map((option) => getOption(option, optionsFormat, optionsName)).join(", ")
                }
                fullWidth
            >
                <MenuItem
                    value="all"
                    disabled={disableEmptySelection && selected?.length === options?.length}
                >
                    <ListItemIcon>
                        <Checkbox
                            checked={options?.length > 0 && selected?.length === options?.length}
                            indeterminate={selected?.length > 0 && selected?.length < options?.length}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Alle auswählen" />
                </MenuItem>
                {options?.map((option) => (
                    <MenuItem
                        key={optionsKey ? option[optionsKey] : option}
                        value={optionsKey ? option[optionsKey] : option}
                        disabled={disableEmptySelection && selected.length === 1 && (value || selected)?.indexOf(optionsKey ? option[optionsKey] : option) !== -1}
                    >
                        <ListItemIcon>
                            <Checkbox checked={(value || selected)?.indexOf(optionsKey ? option[optionsKey] : option) > -1} />
                        </ListItemIcon>
                        <ListItemText primary={getOption(option, optionsFormat, optionsName)} />
                    </MenuItem>
                ))}
            </Select>
        </StyledFormControl>
    );
}

export default CustomMultiSelect;
